import { SxStyle } from '@aibees/shared/theme';

export const content: SxStyle = {
  p: 0,
};

export const aspectFrame: SxStyle = {
  position: 'relative',
  width: '100%',
  aspectRatio: '16 / 9',
  backgroundColor: 'common.black',
  overflow: 'hidden',
};

export const iframe: SxStyle = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  border: 0,
  display: 'block',
};

export const overlay: SxStyle = {
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  pointerEvents: 'none',
};

export const errorOverlay: SxStyle = {
  position: 'absolute',
  inset: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 1.5,
  px: 3,
  textAlign: 'center',
  backgroundColor: 'grey.50',
};

export const spinner: SxStyle = {
  color: 'common.white',
};
